import { Box, Spinner } from "@chakra-ui/react";

const Loader = () => {
  return (
    <Box
      maxH={"100vh"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      h={"100%"}
    >
      <Spinner thickness="3px" size={{ base: "lg", lg: "xl" }} />
    </Box>
  );
};

export default Loader;
